import axios from 'axios';

export const createDynamicLink = async (id: string) => {
  const url = `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=AIzaSyB9gDMOfHPt17qBIv3O80XhWc1Jx_GAVFQ`;
  const requestBody = {
    "dynamicLinkInfo": {
      "domainUriPrefix": "https://pangeaapp.page.link",
      "link": `https://pangeatech.io/invite?uid=${id}`,
      "androidInfo": {
        "androidPackageName": "com.pangeatech.pangea"
      },
      "iosInfo": {
        "iosBundleId": "com.pangeatech.pangea",
        "iosAppStoreId": "1592449564"
      },
      "navigationInfo": {
        "enableForcedRedirect": true
      }
    },
    "suffix": {
        "option": "SHORT"
    },
    
  }

  try {
    const response = await axios.post(url, requestBody);
    console.log(response.data.shortLink)
    return response.data.shortLink;
  } catch (error) {
    console.error('Error creating dynamic link: ', error);
  }
}
